module.exports = __webpack_public_path__ + "img/13.a4a8e15.jpg";